import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { takeUntil } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { Form } from './../../models/forms/forms.model';
import { AppointmentCalendar } from './../../models/calendar/calendar.model';
import { ApiService } from './../../shared/services/api.service';
import { Subject } from 'rxjs';

import * as appConfig from './../../app.config';
import { DataUtils } from './../../shared/utils/data-utils';
import { BookingOffer } from './../../models/bookings/bookings.model';

@Component({
  selector: 'swb-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit, OnDestroy {
  private _finished: Subject<boolean> = new Subject<boolean>();
  public showSideNav = false;
  public forms: Form[];
  public calendars: AppointmentCalendar[];
  public booking_offers: BookingOffer[];
  public activeRoot = '';

  public modules = appConfig.modules;

  constructor(
    private _communicationService: CommunicationService,
    private _apiService: ApiService,
    public router: Router
  ) { }

  ngOnInit() {
    this._communicationService.burgerClicked$.pipe(takeUntil(this._finished)).subscribe((opened: boolean) => {
      this.showSideNav = opened;
    });

    this._communicationService.shouldReloadSubLists$.pipe(takeUntil(this._finished)).subscribe(() => {
      this._loadSubmenus();
    });

    this._loadSubmenus();

    this.router.events.pipe(takeUntil(this._finished)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this._loadSubmenus();
      }
    });

  }

  ngOnDestroy() {
    this._finished.next(true);
  }

  public getTitle(titleObject: any): string {
    return DataUtils.getTitle(titleObject);
  }

  private _loadSubmenus(): void {
    this._apiService.get('forms/list').subscribe((response: any) => {
      this.forms = { ...response }.data;
    });
    if (appConfig.modules.appointments) {
      this._apiService.get('appointment-calendars/list').subscribe((response: any) => {
        this.calendars = { ...response }.data;
      });
    }
    if (appConfig.modules.bookings) {
      this._apiService.get('booking-offers/list').subscribe((response: any) => {
        this.booking_offers = { ...response }.data;
      });
    }
  }

}
